/*
 * Personalizacja haftu — logika panelu.
 *
 * DLACZEGO OSOBNY PLIK, A NIE SKRYPT W SNIPPECIE:
 * po zmianie wariantu Dawn podmienia HTML kolumny z informacjami świeżym
 * fragmentem z serwera. Skrypt osadzony w tym fragmencie nie uruchamia się
 * ponownie, więc panel przestawał reagować (i po kliknięciu „Tak" zostawał
 * ukryty). Tutaj wszystko wisi na delegacji zdarzeń i obserwatorze DOM,
 * więc przeżywa każdą podmianę.
 */
(function () {
  var OPOZNIENIE = 80;

  function panel() {
    return document.querySelector('[data-haft]');
  }

  function wybranyHaft() {
    var zaznaczone = document.querySelectorAll('.product__info-container input[data-option-name]:checked');
    for (var i = 0; i < zaznaczone.length; i++) {
      var nazwa = (zaznaczone[i].getAttribute('data-option-name') || '').toLowerCase();
      if (nazwa.indexOf('haft') !== -1) return (zaznaczone[i].value || '').toLowerCase();
    }
    return '';
  }

  /*
   * Docelowy kadr dla podglądu: GŁÓWNE zdjęcie wariantu, czyli slajd
   * oznaczony przez Dawna klasą `is-active`.
   *
   * Dwie rzeczy, na które trzeba uważać:
   * 1. NIE `.product__media-wrapper` — to cała kolumna galerii (przy pionowych
   *    miniaturach ma kilka tysięcy pikseli wysokości), więc napis lądował
   *    daleko pod ekranem.
   * 2. NIE „pierwszy widoczny slajd" — po przejściu na kolejne zdjęcie haft
   *    wskakiwał na aranżację albo zdjęcie z psem, gdzie nie ma go gdzie
   *    wyhaftować. Podgląd należy tylko do głównego kadru wariantu.
   */
  /*
   * Slajd z GŁÓWNYM zdjęciem wariantu.
   *
   * Nie wystarczy `is-active`: Dawn przestawia tę klasę na każdy kadr, który
   * klient otworzy, więc haft wędrował za nim na aranżacje i zdjęcia z psem.
   * Id głównego media wariantu podaje Liquid w `data-haft-media` (snippet
   * renderuje się ponownie przy każdej zmianie wariantu, więc jest aktualne).
   * Atrybut `data-media-id` slajdu bywa poprzedzony id sekcji — stąd `endsWith`.
   */
  /*
   * ID glownego zdjecia biezacego wariantu.
   *
   * Nie da sie polegac na atrybucie z Liquida: przy zmianie koloru Dawn
   * podmienia galerie (a czasem i kolumne info), wiec wartosc bywa
   * nieaktualna albo znika razem z elementem. Zamiast tego zapamietujemy id
   * kadru, ktory Dawn oznaczy jako aktywny TUZ PO zmianie wariantu — to
   * wlasnie zdjecie danego koloru.
   */
  var mediaWariantu = null;

  function idSlajdu(slajd) {
    var mid = slajd ? slajd.getAttribute('data-media-id') || '' : '';
    // Dawn poprzedza id sekcja:  → bierzemy koncowke
    var czesci = mid.split('-');
    return czesci[czesci.length - 1];
  }

  function slajdAktywny() {
    return document.querySelector('.product__media-list .product__media-item.is-active');
  }

  function slajdGlowny() {
    var slajdy = document.querySelectorAll('.product__media-list .product__media-item');
    if (mediaWariantu) {
      for (var i = 0; i < slajdy.length; i++) {
        if (idSlajdu(slajdy[i]) === mediaWariantu) return slajdy[i];
      }
    }
    return slajdy[0] || null;
  }

  function kadr() {
    var slajd = slajdGlowny();
    if (!slajd) return null;
    return slajd.querySelector('.product__media') || slajd;
  }

  /*
   * Haft widac tylko na glownym zdjeciu wariantu: aktywny kadr musi byc tym
   * zdjeciem i musi byc realnie na ekranie. Po przejsciu na kolejne zdjecie
   * napis znika, po powrocie wraca.
   */
  function kadrWidoczny() {
    var glowny = slajdGlowny();
    var aktywny = slajdAktywny();
    if (!glowny || !aktywny || glowny !== aktywny) return false;
    var p = glowny.getBoundingClientRect();
    if (p.width < 40 || p.height < 40) return false;
    var od = Math.max(p.top, 0);
    var doo = Math.min(p.bottom, window.innerHeight || 0);
    return doo - od > p.height * 0.5;
  }

  /*
   * Pozycja napisu liczona od PROSTOKATA ZDJECIA (nie od kontenera kadru,
   * bo ten ma wlasne proporcje i puste marginesy przy object-fit: contain).
   * Wartosci: lewo%,gora%,obrot,rozmiar% — z metapola produktu albo z mapy
   * w snippets/haft-pozycje.liquid.
   */
  function ustawPozycje(pod, obraz, kontener) {
    var dane = (pod.getAttribute('data-haft-pozycja') || '50,72,-1.5,7').split(',');
    var lewo = parseFloat(dane[0]);
    var gora = parseFloat(dane[1]);
    var obrot = parseFloat(dane[2]);
    var rozmiar = parseFloat(dane[3]);
    if (isNaN(lewo)) lewo = 50;
    if (isNaN(gora)) gora = 72;
    if (isNaN(obrot)) obrot = -1.5;
    if (isNaN(rozmiar)) rozmiar = 7;

    /*
     * `kontener` podajemy tylko dla powiększenia: tam napis wisi w elemencie,
     * który sam się PRZEWIJA (zdjęcie bywa większe od ekranu), więc do
     * współrzędnych trzeba doliczyć przewinięcie. W galerii na karcie
     * odniesieniem jest zwykły rodzic i przewinięcia nie ma.
     */
    var odniesienie = kontener || pod.parentElement;
    var przewX = kontener ? kontener.scrollLeft : 0;
    var przewY = kontener ? kontener.scrollTop : 0;
    var ramka = odniesienie.getBoundingClientRect();
    var kadrObrazu = obraz.getBoundingClientRect();
    pod.style.left = Math.round(kadrObrazu.left - ramka.left + przewX + (kadrObrazu.width * lewo) / 100) + 'px';
    pod.style.top = Math.round(kadrObrazu.top - ramka.top + przewY + (kadrObrazu.height * gora) / 100) + 'px';
    pod.style.right = 'auto';
    pod.style.bottom = 'auto';
    pod.style.fontSize = Math.round((kadrObrazu.height * rozmiar) / 100) + 'px';
    pod.style.transform = 'translate(-50%, -50%) rotate(' + obrot + 'deg)';
  }

  /*
   * Wlasny element podgladu, odtwarzany po kazdej podmianie galerii.
   *
   * Element z Liquida sluzy tylko jako ZRODLO DANYCH (pozycja, id media).
   * Przy zmianie koloru Dawn wymienia cala galerie i wczesniejsza wersja
   * (przenoszony oryginal) po prostu znikala razem z nia — haft przepadal
   * do czasu przeladowania strony.
   */
  var zapamietane = { imie: '', kroj: 'pisana', kolor: '#c62828', pozycja: '50,72,-1.5,7' };

  function zrodloDanych() {
    return document.querySelector('.product__info-container [data-haft-podglad]');
  }

  function podglad() {
    var cel = kadr();
    if (!cel) return null;

    var zrodlo = zrodloDanych();
    if (zrodlo) {
      var poz = zrodlo.getAttribute('data-haft-pozycja');
      if (poz) zapamietane.pozycja = poz;
      // element z Liquida nie ma nic pokazywac — jest tylko nosnikiem danych
      zrodlo.hidden = true;
      zrodlo.style.display = 'none';
    }

    var el = document.querySelector('.product__media-list .haft-podglad--zywy');
    if (!el) {
      el = document.createElement('span');
      el.className = 'haft-podglad haft-podglad--zywy';
      el.setAttribute('aria-hidden', 'true');
    }
    if (el.parentElement !== cel) {
      cel.style.position = 'relative';
      cel.appendChild(el);
    }
    el.setAttribute('data-haft-pozycja', zapamietane.pozycja);
    return el;
  }

  /*
   * HAFT W POWIĘKSZENIU (modal ze zdjęciem, ikona lupy nad kadrem).
   *
   * Klient wpisuje imię, widzi je na kadrze — a po powiększeniu zdjęcia
   * trafiał na gołe legowisko bez haftu (zgłoszone 2026-09-08). Modal Dawna
   * to OSOBNA kopia zdjęć, więc napis z galerii tam nie sięga i trzeba
   * położyć drugi, własny.
   *
   * Pozycja liczy się z tych samych procentów co na karcie
   * (`snippets/haft-pozycje.liquid`), więc skaluje się z każdym rozmiarem
   * zdjęcia — także wtedy, gdy powiększenie jest większe od ekranu.
   */
  function modalKontener() {
    var m = document.querySelector('product-modal');
    if (!m || !m.hasAttribute('open')) return null;
    return m.querySelector('[role="document"]');
  }

  /*
   * Które zdjęcie w powiększeniu jest tym „głównym" wariantu. Na telefonie
   * modal pokazuje tylko `.active`, na desktopie wszystkie naraz — dlatego
   * szukamy po `data-media-id`, a nie po widoczności.
   */
  function obrazModalu(k) {
    var glowny = slajdGlowny();
    if (!glowny) return null;
    var szukane = idSlajdu(glowny);
    var obrazy = k.querySelectorAll('img[data-media-id]');
    for (var i = 0; i < obrazy.length; i++) {
      if (idSlajdu(obrazy[i]) === szukane) return obrazy[i];
    }
    return null;
  }

  function odswiezModal(tekst, krojNazwa, kolorNic, wlaczony) {
    var k = modalKontener();
    if (!k) return;

    var el = k.querySelector('.haft-podglad--modal');
    if (!el) {
      el = document.createElement('span');
      el.setAttribute('aria-hidden', 'true');
      k.appendChild(el);
    }
    // kontener musi być punktem odniesienia dla pozycjonowania bezwzględnego
    if (getComputedStyle(k).position === 'static') k.style.position = 'relative';

    el.className = 'haft-podglad haft-podglad--modal haft-podglad--' + krojNazwa;
    el.setAttribute('data-haft-pozycja', zapamietane.pozycja);
    el.textContent = tekst;
    el.style.setProperty('--nic', kolorNic);

    var obraz = obrazModalu(k);
    var gotowy = obraz && obraz.getBoundingClientRect().width > 40;
    if (gotowy) ustawPozycje(el, obraz, k);
    el.hidden = !wlaczony || tekst.length === 0 || !gotowy;

    // zdjęcie w powiększeniu bywa doczytywane — po chwili mierzymy jeszcze raz
    if (obraz && !gotowy) setTimeout(odswiez, 250);
  }

  /*
   * Wpisane imie i wybory musza przezyc zmiane wariantu: Dawn potrafi
   * podmienic kolumne z informacjami, a wtedy pola wracaja puste.
   * Trzymamy wartosci w pamieci i wstawiamy je z powrotem.
   */
  function zapamietaj(p) {
    var imie = p.querySelector('[data-haft-imie]');
    var kroj = p.querySelector('[data-haft-kroj]:checked');
    var kolor = p.querySelector('[data-haft-kolor]:checked');
    if (imie && imie.value) zapamietane.imie = imie.value;
    if (kroj) zapamietane.kroj = kroj.getAttribute('data-haft-kroj');
    if (kolor) zapamietane.kolor = kolor.getAttribute('data-haft-kolor');
  }

  function przywroc(p) {
    var imie = p.querySelector('[data-haft-imie]');
    if (imie && !imie.value && zapamietane.imie) imie.value = zapamietane.imie;

    var kroj = p.querySelector('[data-haft-kroj="' + zapamietane.kroj + '"]');
    if (kroj && !kroj.checked) kroj.checked = true;

    var kolor = p.querySelector('[data-haft-kolor="' + zapamietane.kolor + '"]');
    if (kolor && !kolor.checked) kolor.checked = true;
  }

  function odswiez() {
    var p = panel();
    if (!p) return;

    zapamietaj(p);
    przywroc(p);

    var imie = p.querySelector('[data-haft-imie]');
    var licznik = p.querySelector('[data-haft-licznik]');
    var uwaga = p.querySelector('[data-haft-uwaga]');
    var kroj = p.querySelector('[data-haft-kroj]:checked');
    var kolor = p.querySelector('[data-haft-kolor]:checked');

    var wlaczony = wybranyHaft().indexOf('tak') !== -1;
    p.hidden = !wlaczony;

    /*
     * Samo `hidden` NIE wystarczy: ukryte pola formularza dalej lecą z
     * żądaniem, więc przy „Haft: Nie" do koszyka trafiały „Czcionka haftu"
     * i „Kolor haftu". `disabled` też NIE wystarczy: „Dodaj do koszyka"
     * (FormData) pola disabled pomija, ale przycisk „Kup teraz" (dynamic
     * checkout Shopify) serializuje formularz po swojemu i bierze je mimo to.
     * Jedyne pewne wyjście: przy „Nie" pole nie ma atrybutu `name` — nazwę
     * trzymamy w `data-haft-name` i przywracamy przy „Tak". Snippet renderuje
     * ten stan już po stronie serwera, tu tylko przełączamy po zmianie wariantu.
     */
    var pola = p.querySelectorAll('[name^="properties["], [data-haft-name]');
    for (var i = 0; i < pola.length; i++) {
      var pole = pola[i];
      if (wlaczony) {
        var nazwa = pole.getAttribute('data-haft-name');
        if (nazwa) {
          pole.setAttribute('name', nazwa);
          pole.removeAttribute('data-haft-name');
        }
        pole.disabled = false;
      } else {
        if (pole.getAttribute('name')) {
          pole.setAttribute('data-haft-name', pole.getAttribute('name'));
          pole.removeAttribute('name');
        }
        pole.disabled = true;
      }
    }

    if (imie) imie.required = wlaczony;

    var tekst = imie ? imie.value.trim() : '';
    if (licznik && imie) licznik.textContent = imie.value.length;
    if (uwaga) uwaga.hidden = !wlaczony || tekst.length > 0;

    var krojNazwa = kroj ? kroj.getAttribute('data-haft-kroj') : zapamietane.kroj;
    var kolorNic = kolor ? kolor.getAttribute('data-haft-kolor') : zapamietane.kolor;

    // Powiększenie ma własny napis — patrz odswiezModal()
    odswiezModal(tekst, krojNazwa, kolorNic, wlaczony);

    var pod = podglad();
    if (!pod) return;

    pod.textContent = tekst;
    pod.className = 'haft-podglad haft-podglad--zywy haft-podglad--' + krojNazwa;
    pod.style.setProperty('--nic', kolorNic);

    var obraz = pod.parentElement ? pod.parentElement.querySelector('img') : null;
    if (obraz) ustawPozycje(pod, obraz);

    pod.hidden = !wlaczony || tekst.length === 0 || !kadrWidoczny();
  }

  /*
   * Mostek dla trybu kalibracji (drugi blok w tym pliku).
   *
   * Kalibrator do 2026-09-02 chwytał element z Liquida (`[data-haft-podglad]`),
   * ale ten od czasu przejścia na „żywy" podgląd jest wyłącznie nośnikiem
   * danych i dostaje `display: none` — nie było czego przeciągać. Teraz rusza
   * elementem z galerii, a pozycję zapisuje przez ten mostek, żeby trafiła
   * jednocześnie do pamięci skryptu i do znacznika, z którego czyta `podglad()`.
   */
  window.__haft = {
    odswiez: odswiez,
    zywy: function () {
      return document.querySelector('.product__media-list .haft-podglad--zywy');
    },
    czytajPozycje: function () {
      return zapamietane.pozycja;
    },
    zapiszPozycje: function (tekst) {
      zapamietane.pozycja = tekst;
      var zrodlo = zrodloDanych();
      if (zrodlo) zrodlo.setAttribute('data-haft-pozycja', tekst);
      var el = window.__haft.zywy();
      if (el) el.setAttribute('data-haft-pozycja', tekst);
      odswiez();
    },
  };

  document.addEventListener('input', function (e) {
    var pole = e.target.closest('[data-haft-imie]');
    if (!pole) return;

    // Same litery, spacje, myślnik i apostrof — cyfr i emoji nie da się wyhaftować
    var czyste = pole.value.replace(/[^\p{L}\s'-]/gu, '').slice(0, 10);
    /*
     * Podmieniamy wartość TYLKO gdy naprawdę coś odsialiśmy: każde przypisanie
     * do `.value` przestawia kursor na koniec pola, więc poprawianie środka
     * imienia (np. dopisanie litery po pierwszej) byłoby nie do przejścia.
     */
    if (czyste !== pole.value) pole.value = czyste;

    /*
     * To, co klient wpisał, jest ostatecznym stanem pola — także wtedy, gdy
     * skasował wszystko. Bez tej linii `przywroc()` widziało puste pole
     * i wstawiało z powrotem ostatnie zapamiętane imię: po skasowaniu
     * ostatniej litery natychmiast wracała i pola nie dało się wyczyścić
     * (zgłoszone 2026-09-02).
     *
     * Czyszczenia NIE można przenieść do `zapamietaj()` — tamto leci również
     * po podmianie kolumny przez Dawna, gdzie puste pole oznacza świeży HTML,
     * a nie decyzję klienta, i skasowałoby wpisane imię przy zmianie wariantu.
     */
    zapamietane.imie = pole.value;

    odswiez();
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-haft]') || e.target.closest('.product__info-container .product-form__input')) {
      // opóźnienie, bo Dawn przy zmianie wariantu podmienia fragment sekcji
      setTimeout(function () {
        // zmiana opcji = inne zdjęcie główne; zapamiętujemy je jako kadr haftu
        if (e.target.closest('.product__info-container .product-form__input')) {
          var akt = slajdAktywny();
          if (akt) mediaWariantu = idSlajdu(akt);
        }
        odswiez();
      }, 400);
    }
  });

  function start() {
    if (!panel()) return;
    var zrodlo = zrodloDanych();
    var zLiquida = zrodlo ? zrodlo.getAttribute('data-haft-media') : '';
    mediaWariantu = zLiquida || (slajdAktywny() ? idSlajdu(slajdAktywny()) : null);
    odswiez();

    // Przewijanie galerii i zmiana rozmiaru okna zmieniają to, który kadr
    // jest na ekranie — haft ma znikać razem z głównym zdjęciem.
    window.addEventListener('scroll', odswiez, { passive: true });
    window.addEventListener('resize', odswiez, { passive: true });
    var lista = document.querySelector('.product__media-list');
    if (lista) lista.addEventListener('scroll', odswiez, { passive: true });
    var korzen = document.querySelector('.product__info-container');
    if (!korzen || !window.MutationObserver) return;
    var czeka = false;
    new MutationObserver(function () {
      if (czeka) return;
      czeka = true;
      setTimeout(function () {
        czeka = false;
        odswiez();
      }, OPOZNIENIE);
    }).observe(korzen, { childList: true, subtree: true });

    /*
     * Powiększenie: reagujemy na otwarcie modala (atrybut `open`) i na zmianę
     * aktywnego zdjęcia w środku (Dawn przestawia klasę `active`). Bez tego
     * napis pojawiłby się dopiero po jakiejkolwiek zmianie w formularzu.
     * Modal przewija się własnym kontenerem — stąd nasłuch na jego scroll.
     */
    var modal = document.querySelector('product-modal');
    if (!modal) return;
    var czekaModal = false;
    new MutationObserver(function () {
      if (czekaModal) return;
      czekaModal = true;
      setTimeout(function () {
        czekaModal = false;
        odswiez();
      }, 80);
    }).observe(modal, { attributes: true, attributeFilter: ['open', 'class'], subtree: true });

    var tresc = modal.querySelector('[role="document"]');
    if (tresc) tresc.addEventListener('scroll', odswiez, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/*
 * TRYB KALIBRACJI — ustawianie miejsca haftu myszką.
 *
 * Włącza się parametrem `?haft-kalibracja=1` w adresie karty produktu.
 * Napis można przeciągać, kółkiem myszy zmienia się rozmiar liter,
 * a Shift+kółko obraca. Panel na dole pokazuje gotową linię do wklejenia
 * w snippets/haft-pozycje.liquid albo w metapole `custom.haft_pozycja`.
 *
 * Po co: pozycja jest inna dla każdego zdjęcia produktu, a zgadywanie
 * z ekranu i poprawianie w kodzie zajmuje więcej czasu niż przeciągnięcie.
 */
(function () {
  if (new URLSearchParams(location.search).get('haft-kalibracja') !== '1') return;

  function start() {
    if (!document.querySelector('[data-haft-podglad]')) return;
    document.body.classList.add('haft-kalibracja');

    var panel = document.createElement('div');
    panel.className = 'haft-kalibrator';
    panel.innerHTML =
      '<strong>Kalibracja haftu</strong>' +
      '<span data-kalib-stan>Przeciągnij napis · kółko = rozmiar · Shift+kółko = obrót</span>' +
      '<code data-kalib-wynik></code>';
    document.body.appendChild(panel);
    var wynik = panel.querySelector('[data-kalib-wynik]');
    var stan = panel.querySelector('[data-kalib-stan]');

    /*
     * Napis rysuje się dopiero przy Haft = Tak i niepustym imieniu, więc
     * w trybie kalibracji sami ustawiamy oba warunki — inaczej otwarcie
     * adresu z `?haft-kalibracja=1` kończyło się pustym kadrem.
     *
     * Klikamy DOPIERO po tym, jak przeglądarka ożywi `<variant-selects>`:
     * wcześniej `.click()` zaznacza radio, ale Dawn tego nie widzi i strona
     * zostaje przy cenie wariantu bez haftu.
     */
    function przygotuj() {
      var gotowe = window.customElements && customElements.whenDefined
        ? customElements.whenDefined('variant-selects')
        : Promise.resolve();
      gotowe.then(function () {
        setTimeout(pilnuj, 200);
      });
    }

    function przyciskTak() {
      var opcje = document.querySelectorAll('.product__info-container input[data-option-name]');
      for (var i = 0; i < opcje.length; i++) {
        var nazwa = (opcje[i].getAttribute('data-option-name') || '').toLowerCase();
        if (nazwa.indexOf('haft') !== -1 && opcje[i].value === 'Tak') return opcje[i];
      }
      return null;
    }

    /*
     * Realny stan wariantu bierzemy z JSON-a, który Dawn wstawia do
     * `<variant-selects>` — samo `radio.checked` kłamie, bo `.click()`
     * zaznacza kafel także wtedy, gdy sekcja się nie przerysowała.
     */
    function haftWWariancie() {
      var el = document.querySelector('[data-selected-variant]');
      if (!el) return null;
      try {
        var v = JSON.parse(el.textContent);
        var opcje = [v.option1, v.option2, v.option3];
        for (var i = 0; i < opcje.length; i++) {
          if (opcje[i] === 'Tak' || opcje[i] === 'Nie') return opcje[i];
        }
      } catch (e) {}
      return null;
    }

    function pilnuj() {
      var prob = 0;
      var ostatniKlik = -99;
      var zegar = setInterval(function () {
        prob++;
        if (prob > 50) {
          clearInterval(zegar);
          if (!zywy()) stan.textContent = 'Brak podglądu — sprawdź, czy produkt ma opcję Haft.';
          return;
        }

        if (haftWWariancie() === 'Nie') {
          // Ponawiamy co ~2,5 s: pierwszy klik bywa zjadany przy podmianie sekcji
          if (prob - ostatniKlik > 8) {
            ostatniKlik = prob;
            var tak = przyciskTak();
            if (tak) tak.click();
          }
          return;
        }

        var pole = document.querySelector('[data-haft-imie]');
        if (pole && !pole.value) {
          pole.value = 'Riva';
          pole.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }

        if (window.__haft) window.__haft.odswiez();
        if (zywy()) {
          clearInterval(zegar);
          zapisz(czytaj());
        }
      }, 300);
    }

    function zywy() {
      return window.__haft ? window.__haft.zywy() : null;
    }

    function obraz() {
      var el = zywy();
      return el && el.parentElement ? el.parentElement.querySelector('img') : null;
    }

    function czytaj() {
      var zrodlo = window.__haft ? window.__haft.czytajPozycje() : '50,72,-1.5,7';
      var d = (zrodlo || '50,72,-1.5,7').split(',').map(parseFloat);
      return { lewo: d[0] || 50, gora: d[1] || 72, obrot: d[2] || 0, rozmiar: d[3] || 7 };
    }

    function zapisz(w) {
      var tekst =
        Math.round(w.lewo * 10) / 10 + ',' + Math.round(w.gora * 10) / 10 + ',' +
        Math.round(w.obrot * 10) / 10 + ',' + Math.round(w.rozmiar * 10) / 10;
      var uchwyt = (location.pathname.split('/products/')[1] || '').split('?')[0];
      wynik.textContent = "when '" + uchwyt + "'\n  assign pozycja = '" + tekst + "'";
      if (window.__haft) window.__haft.zapiszPozycje(tekst);
    }

    /*
     * Zdarzenia wieszamy na dokumencie, a nie na samym napisie: „żywy" podgląd
     * jest odtwarzany przy każdej podmianie galerii (zmiana koloru, zmiana
     * kadru), więc uchwyt przypięty do konkretnego elementu ginąłby razem z nim.
     */
    var ciagnie = false;

    document.addEventListener('pointerdown', function (e) {
      var el = e.target.closest('.haft-podglad--zywy');
      if (!el) return;
      ciagnie = true;
      el.setPointerCapture(e.pointerId);
      el.style.cursor = 'grabbing';
      // Bez tego przeglądarka zaczyna zaznaczać zdjęcie i tekst zamiast ciągnąć
      document.body.style.userSelect = 'none';
      e.preventDefault();
    });

    // Obrazki mają natywne przeciąganie (drag & drop) — blokujemy je w kalibracji
    document.addEventListener('dragstart', function (e) {
      if (ciagnie) e.preventDefault();
    });

    document.addEventListener('pointermove', function (e) {
      if (!ciagnie) return;
      var img = obraz();
      if (!img) return;
      e.preventDefault();
      var p = img.getBoundingClientRect();
      var w = czytaj();
      w.lewo = ((e.clientX - p.left) / p.width) * 100;
      w.gora = ((e.clientY - p.top) / p.height) * 100;
      zapisz(w);
    });

    function koniec() {
      if (!ciagnie) return;
      ciagnie = false;
      var el = zywy();
      if (el) el.style.cursor = 'grab';
      document.body.style.userSelect = '';
    }

    document.addEventListener('pointerup', koniec);
    document.addEventListener('pointercancel', koniec);

    document.addEventListener('wheel', function (e) {
      if (!e.target.closest('.haft-podglad--zywy')) return;
      e.preventDefault();
      var w = czytaj();
      if (e.shiftKey) w.obrot += e.deltaY > 0 ? 1 : -1;
      else w.rozmiar = Math.max(2, w.rozmiar + (e.deltaY > 0 ? -0.3 : 0.3));
      zapisz(w);
    }, { passive: false });

    /*
     * Dawn po każdej zmianie wariantu przepisuje adres na sam `?variant=…`
     * (product-info.js → updateURL) i flaga kalibracji z niego znika —
     * po odświeżeniu strony tryb już by się nie włączył. Dopisujemy ją z powrotem.
     */
    setInterval(function () {
      if (location.search.indexOf('haft-kalibracja=1') !== -1) return;
      var p = new URLSearchParams(location.search);
      p.set('haft-kalibracja', '1');
      history.replaceState({}, '', location.pathname + '?' + p.toString());
    }, 1000);

    przygotuj();
    zapisz(czytaj());
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
